import { Link } from "react-router-dom";

export default function SectionTitle({
  eyebrow,
  title,
  desc,
  moreTo,
}: {
  eyebrow?: string;
  title: string;
  desc?: string;
  moreTo?: string;
}) {
  return (
    <div className="mb-8 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-accent-400">
            <span className="h-px w-7 bg-accent-500" />
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">{title}</h2>
        {desc && <p className="mt-2 max-w-xl text-sm text-foreground-600">{desc}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex items-center gap-1 whitespace-nowrap text-sm font-bold text-primary-400 transition-colors hover:text-primary-300"
        >
          查看全部 <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}